/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
import type { Conditional } from './types.tsx';

export const getConditional = <T extends number | string | boolean>(
	{ conditional: conditions, default: defaultValue }: Conditional<T>,
	variants: string[],
): T => {
	if (conditions === undefined) {
		return defaultValue;
	}

	const variantsIncludesCondition = (c: string) => variants.includes(c);

	const conditionObj = conditions.find(({ condition }) =>
		condition.every(variantsIncludesCondition),
	);

	return conditionObj ? conditionObj.value : defaultValue;
};
